<template>
  <div>
    <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatList" :key="i.seat">
      <ul>
        <li>姓名：{{ i.name || "" }}</li>
        <li>区域：{{ i.region }}区</li>
        <li>座位：{{ i.seat }}</li>
        <li>一级部门：{{ i.oneDepartment }}</li>
        <li>二级部门：{{ i.twoDepartment }}</li>
        <li>三级部门：{{ i.threeDepartment }}</li>

      </ul>
      <el-button :id='i.name' :class="classTd + ' ' + i.name+' ' + (i.seat.indexOf('notUsed')>-1?'notUsed':'')" slot="reference"
        :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
        {{ i.name ? i.name : "空置" }}</el-button>
    </el-popover>
  </div>
</template>
<script>
export default {
  props: {
    seatList: {
      type: Array,
      default() {
        return []
      }
    },
    classTd: {
      type: String,
      default() {
        return ''
      }
    }
  },
  watch: {
    seatList: {
      handler: function(newVal) {
      },
      immediate: true,
      deep: true
    }

  },
  mounted() {
    // console.log(999888111, this.seatList)
  }
}
</script>
<style lang="scss" scoped>
  .notUsed{
    visibility: hidden
  }
</style>
